module.exports = require("next/dist/compiled/@ampproject/toolbox-optimizer");